<template>
  <div class="intro">
    <p>
      <span class="caps">L</span>ondres, début de l'époque Victorienne. Un meurtre
      sanguinaire a été commis et la police piétine. Il semblerait que
      l'assassin soit suffisamment riche pour avoir réussi à effacer ses
      traces et faire taire tout témoin. Impossible pour l'inspecteur
      Lestrade d'avoir ne serait-ce qu'un début de piste...
    </p>
    <p>
      Ce n'est pas la première fois qu'un tel cas se présente, et
      son joker est alors de faire appel à vous. Vous n'êtes pas de la
      police, mais vous avez un atout de taille : votre voisine, une
      bohémienne sujette à des crises d'hystérie, et se disant voyante,
      semble réussir à entrer en communication avec le monde des
      esprits. Et ces derniers possèdent des réponses que les hommes
      n'ont pas. Elle ne fait pas vraiment confiance à la police et
      préfère que vous restiez son seul intermédiaire. Les précédents
      cas n'ont pas toujours été simples, en effet, les âmes passées à
      trépas ont l'habitude de communiquer par messages codés. Les
      comprendre demande donc un minimum de connaissances en
      cryptographie. Cela tombe bien, c'est votre spécialité ! C'est la
      raison pour laquelle la police ne peut pas se passer de vos
      services.
    </p>
    <p>
      Les premières affaires sur lesquelles vous avez enquêté
      n'étaient pas simples, mais votre improbable duo a réussi à faire
      ses preuves. Vous voilà donc une nouvelle fois dans le bureau de
      Lestrade pour découvrir la situation qui requiert votre
      présence...
    </p>
  </div>
</template>
<script>
export default {
  name: "Intro"
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.intro {
  padding: 5% 10%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 90%;
}
.caps {
  color: rgba(0, 0, 0, 0.7);
  float: left;
  font-size: 110px;
  line-height: 0.8em;
  padding-right: 12px;
  position: relative;
  top: 8px;
}
</style>